import React, {useEffect, useState} from 'react';
import {useList} from "react-use";
import lodash from 'lodash';
import Checkbox from "../../../../../components/checkbox";

import {Collapse} from 'react-collapse';

function BattingOrder(props) {
    const {selected} = props;
    const [isOpened, setIsOpened] = useState(false);
    const [listBattingOrder, listBattingOrderHelper] = useList([
        {
            value: 1,
            name: '1番',
            checked: false,
        },
        {
            value: 2,
            name: '2番',
            checked: false,
        },
        {
            value: 3,
            name: '3番',
            checked: false,
        },
        {
            value: 4,
            name: '4番',
            checked: false,
        },
        {
            value: 5,
            name: '5番',
            checked: false,
        },
        {
            value: 6,
            name: '6番',
            checked: false,
        },
        {
            value: 7,
            name: '7番',
            checked: false,
        },
        {
            value: 8,
            name: '8番',
            checked: false,
        },
        {
            value: 9,
            name: '9番',
            checked: false,
        },
        {
            value: true,
            name: 'クリーンアップ',
            checked: false,
        },
        {
            value: 10,
            name: '代打',
            checked: false,
        },
    ]);
    const [condition, setCondition] = useState(selected);

    useEffect(() => {
        const arr = [...condition];
        const index = lodash.findIndex(listBattingOrder, item => lodash.isBoolean(item.value));
        if(lodash.includes(arr, 3) && lodash.includes(arr, 4) && lodash.includes(arr, 5)){
            listBattingOrderHelper.updateAt(index, {...listBattingOrder[index], checked: true});
        }else {
            listBattingOrderHelper.updateAt(index, {...listBattingOrder[index], checked: false});
        }
        arr.map(item => {
            const i = lodash.findIndex(listBattingOrder, val => val.value === item);
            listBattingOrderHelper.updateAt(i, {...listBattingOrder[i], checked: true});
        })
        props.onChange(condition)
    },[condition, selected])

    const onChange = (item, index) => {
        const arr = [...condition];
        if(lodash.includes(arr, item.value)) {
            lodash.pull(arr, item.value)
        }else {
            arr.push(item.value)
        }
        setCondition(arr);
        listBattingOrderHelper.updateAt(index,{...item, checked: !item.checked});
    }

    const onCheckArr = (item, index) =>  {
        let arr = [...condition];
        const subArr = [3,4,5];
        if(!item.checked) {
            arr = lodash.union(arr, subArr)
        }else {
            lodash.pull(arr, 3,4,5);
        }
        setCondition(arr);
        subArr.map((val) => {
            const raw = listBattingOrder.findIndex(i => i.value === val);
            listBattingOrderHelper.updateAt(raw, {...listBattingOrder[raw], checked: !item.checked});
        })
        listBattingOrderHelper.updateAt(index,{...item, checked: !item.checked});
    }
    return (
        <div className='group-filter-item'>
            <div className={'open-collapse'}>
                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>打順</h4>
                    <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
                </div>
                <Collapse isOpened={isOpened}>
                    <div className="search-group">
                        {listBattingOrder.map((item, index) => {
                            return <div key={item.value} className={'search-main-advanced-checkbox'}>
                                {lodash.isBoolean(item.value) ?
                                    <label>
                                        <Checkbox onChange={() => onCheckArr(item, index)} value={item.value} checked={item.checked}/>
                                        {item.name}
                                    </label>
                                    :
                                    <label>
                                        <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                        {item.name}
                                    </label>

                                }

                            </div>
                        })}
                    </div>
                </Collapse>
            </div>
            <div className={'close-collapse'}>
                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>打順</h4>
                </div>
                    <div className="search-group">
                        {listBattingOrder.map((item, index) => {
                            return <div key={item.value} className={'search-main-advanced-checkbox'}>
                                {lodash.isBoolean(item.value) ?
                                    <label>
                                        <Checkbox onChange={() => onCheckArr(item, index)} value={item.value} checked={item.checked}/>
                                        {item.name}
                                    </label>
                                    :
                                    <label>
                                        <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                        {item.name}
                                    </label>

                                }

                            </div>
                        })}
                    </div>
            </div>
        </div>
    )
}

export default BattingOrder;
